import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import DeleteAccountConfirm from './DeleteAccountConfirm'
import DeleteAccountSuccess from './DeleteAccountSuccess'

const DeleteAccount = () => {
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false)
  const [isDeleteSuccessOpen, setIsDeleteSuccessOpen] = useState(false)

  const handleDeleteClick = () => {
    setIsDeleteConfirmOpen(true)
  }

  const handleCloseDeleteConfirm = () => {
    setIsDeleteConfirmOpen(false)
  }

  const handleOpenDeleteSuccess = () => {
    setIsDeleteSuccessOpen(true)
  }

  return (
    <div className="mt-[24px] border-[1px] border-solid border-[#FFCA84] rounded-[10px] p-[20px]">
      <h4 className="text-sm text-primary-100 font-semibold">Account Suspend & Deletion</h4>

      <p className="my-[10px] text-sm font-normal text-primary-100">
        Deleting your account will remove all of your content and data associated with it.
        <br />
        Would you like to delete your Apolo account:
        <Link className="font-semibold">&nbsp;@account_name?</Link>
      </p>

      <button className="flex items-center" onClick={handleDeleteClick}>
        <img src="/assets/image/Warning_Red_20_20.png" className="w-[20px] h-[20px]" alt="Info" />

        <span className="ml-[8px] font-semibold text-sm text-[#EF4343]">
          I want to delete my account
        </span>
      </button>

      <DeleteAccountConfirm
        open={isDeleteConfirmOpen}
        onClose={handleCloseDeleteConfirm}
        onSuccessOpen={handleOpenDeleteSuccess}
      />

      <DeleteAccountSuccess open={isDeleteSuccessOpen} />
    </div>
  )
}

export default DeleteAccount
